import { reviewRatingState } from "@/core/models/project-rating";

export default {
  getAllProjectReviewList: (state: reviewRatingState) =>
    state.allProjectReviewList,
  getTradePassportRedirect: (state: reviewRatingState) =>
    state.showTradePassportRedirect,
};
